'use client';

import { useState } from 'react';
import { cn } from '@/lib/utils';

// md is the Overview's size; sm fits dense rows (tables, list headers).
const SIZES = {
  sm: { box: 'size-6 rounded-md', text: 'text-[10px]' },
  md: { box: 'size-8 rounded-lg', text: 'text-xs' },
} as const;

export function CompanyAvatar({
  name,
  url,
  size = 'md',
}: {
  name: string;
  url?: string;
  size?: 'sm' | 'md';
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
  const { box, text } = SIZES[size];
  if (url && failedUrl !== url) {
    return (
      <img
        src={url}
        alt=""
        loading="lazy"
        className={cn(
          box,
          'shrink-0 border border-[var(--fd-line)] bg-white object-contain',
        )}
        onError={() => setFailedUrl(url)}
      />
    );
  }
  return (
    <span
      aria-hidden
      className={cn(
        box,
        text,
        'flex shrink-0 items-center justify-center bg-[var(--fd-bg-2)] font-semibold',
      )}
    >
      {initials}
    </span>
  );
}
